import { ChefHat, Flame, Leaf, Baby, Coffee, Plus } from "lucide-react";

// Prices from the August 2026 menu. priceValue = lowest price (for structured data).
export const menuCategories = [
  {
    key: "plates",
    title: { en: "Plates", es: "Platos" },
    icon: ChefHat,
    note: { en: "Every plate comes with 8 oz consomé. Add Rice $0.50 | Add Beans $0.50", es: "Cada plato incluye 8 oz de consomé. Agrega arroz $0.50 | Agrega frijoles $0.50" },
    items: [
      { name: "Quesabirria Tacos", price: "$15.99 / $19.99", priceValue: 15.99, description: "Double corn tortilla quesadilla tacos with birria (3 tacos / 4 tacos)" },
      { name: "Quesa-Loca Tacos", price: "$17.99 / $21.99", priceValue: 17.99, description: "Double corn tortilla quesadilla tacos with nacho cheese, birria and Hot Cheetos (3 tacos / 4 tacos)" },
      { name: "Tacos Dorados", price: "$14.99", priceValue: 14.99, description: "4 single fried corn tortilla tacos with cheese and birria" },
      { name: "Tacos Güeros", price: "$13.99 / $12.99", priceValue: 12.99, description: "4 warm soft tacos with birria (with cheese / without cheese)" },
      { name: "Quesazilla", price: "$14.99 / $16.99", priceValue: 14.99, description: "Flour quesadilla fried with cheese and birria, cut into 4 (12 in / 14 in) — California style" },
      { name: "Birria Burrito", price: "$14.99", priceValue: 14.99, description: "Loaded with rice, beans, melted cheese, sour cream, chipotle crema and birria. Add French Fries +$1.50, Add Hot Cheetos +$0.99" },
    ],
  },
  {
    key: "specialties",
    title: { en: "Specialties", es: "Especialidades" },
    icon: Flame,
    note: { en: "The dishes people drive across town for.", es: "Los platillos por los que la gente cruza la ciudad." },
    items: [
      { name: "Birria Ramen", price: "$14.99", priceValue: 14.99, description: "Ramen cooked in our consomé, layered with meat, cheese, onion and cilantro. Add 2 Tacos Dorados +$3.50" },
      { name: "Birria Nachos", price: "$14.99", priceValue: 14.99, description: "Homemade chips, nacho cheese, birria, beans, onion, cilantro and sour cream" },
      { name: "Birria Fries", price: "$15.99", priceValue: 15.99, description: "French fries, nacho cheese, birria, queso fresco, sour cream, chipotle crema, onion and cilantro" },
      { name: "Chilaquiles Rojos", price: "$14.49", priceValue: 14.49, description: "Homemade chips in red sauce with cheese, birria, queso fresco and sour cream. Add Egg +$0.99, Add Beans +$0.50" },
      { name: "Birria Pizza", price: "$41.99", priceValue: 41.99, description: "Three 14\" flour tortillas layered with cheese and birria, topped with queso fresco, sour cream, chipotle crema, onions and cilantro. Served with limes, nacho cheese and 2 consomés" },
    ],
  },
  {
    key: "alacarte",
    title: { en: "A La Carte", es: "Por Pieza" },
    icon: Leaf,
    note: { en: "Build your own plate one taco at a time", es: "Arma tu plato taco por taco" },
    items: [
      { name: "Quesabirria Taco", price: "$4.99", priceValue: 4.99 },
      { name: "Quesa-Loca Taco", price: "$5.75", priceValue: 5.75 },
      { name: "Taco Dorado", price: "$3.75", priceValue: 3.75 },
      { name: "Mulita", price: "$4.99", priceValue: 4.99 },
      { name: "Keto Taco", price: "$4.99", priceValue: 4.99 },
      { name: "Soft Taco with cheese", price: "$3.15", priceValue: 3.15 },
      { name: "Soft Taco without cheese", price: "$2.75", priceValue: 2.75 },
      { name: "Side of Rice (8 oz)", price: "$2.49", priceValue: 2.49 },
      { name: "Side of Beans (8 oz)", price: "$2.49", priceValue: 2.49 },
    ],
  },
  {
    key: "kids",
    title: { en: "Kids", es: "Para Niños" },
    icon: Baby,
    items: [
      { name: "Flour Quesadilla", price: "$8.00", priceValue: 8, description: "Add meat +$3.50" },
      { name: "Two Corn Quesadillas", price: "$8.00", priceValue: 8, description: "Add meat +$3.50" },
      { name: "Birria Ramen (16 oz)", price: "$10.00", priceValue: 10 },
    ],
  },
  {
    key: "drinks",
    title: { en: "Drinks", es: "Bebidas" },
    icon: Coffee,
    note: { en: "Straight from the cooler", es: "Directo del refrigerador" },
    items: [
      { name: "Agua Fresca", price: "$4.99", priceValue: 4.99 },
      { name: "Mexican Coke", price: "$4.99", priceValue: 4.99 },
      { name: "Jarritos", price: "$3.99", priceValue: 3.99 },
      { name: "Squirt", price: "$3.99", priceValue: 3.99 },
      { name: "Arizona Tea", price: "$2.50", priceValue: 2.5 },
      { name: "Canned Soda", price: "$1.99", priceValue: 1.99 },
    ],
  },
  {
    key: "extras",
    title: { en: "Extras", es: "Extras" },
    icon: Plus,
    note: { en: "Add to anything you like", es: "Agrégalo a lo que quieras" },
    items: [
      { name: "Nacho Cheese", price: "$2.00", priceValue: 2 },
      { name: "Hot Cheetos", price: "$1.50", priceValue: 1.5 },
      { name: "Egg", price: "$0.99", priceValue: 0.99 },
      { name: "Chiles Toreados", price: "$0.50", priceValue: 0.5 },
      { name: "Sour Cream", price: "$0.50", priceValue: 0.5 },
      { name: "Consomé (8 oz)", price: "$3.50", priceValue: 3.5 },
    ],
  },
];
